<template>
  <div>
   
     <vs-row class="mt-1" vs-w="12">
  <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
      <vs-select
      autocomplete
      width="310px"
      class="selectExample ml-3 mb-2"
      label="Network"
      v-model="item"
      @change="actionchange(item)"
      >
      <vs-select-item :key="item.id" :value="item" :text="item.name" v-for="item in nwlist" />
    </vs-select>
  </vs-col>
  <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
   
  </vs-col>
  
</vs-row>
 <vs-row  vs-w="12">
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
     <div>
      <label class="ml-4 labelInput "  for="fname">Serial Code 
       <iconStar/>
      </label>
     <vs-input color="#333f50" 
        style="width: 310px" 
        class="inputx ml-3"
        type="string"
        placeholder="Code"
        v-model="serial"
        @change="datachange"
      />
     </div>
  </vs-col>
  <vs-col class="mb-3" vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
     <div>
      <label class="ml-4 labelInput "  for="fname">Security Code 
       <iconStar/>
      </label>
      <vs-input color="#333f50" 
      style="width: 310px" 
        class="inputx ml-3"
        type="string"
        placeholder="Code"
        v-model="security"
        @change="datachange"
      /></div>
  </vs-col>
  
</vs-row>
<vs-row  vs-w="12">
  <vs-col class="mb-3 " vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
    <div>
      <label class="ml-4 labelInput "  for="fname">Device Name 
       <iconStar/>
      </label>
    <vs-input color="#333f50" 
     style="width: 310px"
        class="inputx ml-3"
        type="string"
        placeholder="Name"
        v-model="name"
      />
    </div>
  </vs-col>
  <vs-col class="mb-3 " vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    <vs-input color="#333f50" 
    style="width: 310px"
        label="Gateway Type  "
        readonly
        class="inputx ml-3"
        type="string"
        placeholder="Type"
        v-model="type"
      />
  
  </vs-col>
  
</vs-row>



<vs-row class="ml-3 mt-3" vs-w="12">
 <vs-spacer />
    <vs-button type="filled" size="sm" style="border-radius: 20px;" color="success"  @click="adddev()" >Add Gateway</vs-button>
 <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
 
</vs-row>




  </div>
</template>

<script>
import iconStar from '../Button/iconStar.vue'
export default {
  name: "AddGateway",
  data: () => ({
    nwname: '',
    nwid: '',
    nwlist: [],
    serial: '',
    name: '',
    security: '',
    type: '',
    loraid: '',
  }),
  components: {
    iconStar
  },
  methods:{
    cancel() {
     location.reload()
    },
    datachange() {
      if((this.serial != null && this.serial != '') && (this.security != null && this.security != '')) {
        this.$http.get(this.$url+'searchgateway/'+this.serial+'/'+this.security).then((result) => {
          this.name = result.data[0].name
          this.type = result.data[0].type
          if(result.data[0].gwid) this.loraid = result.data[0].gwid
          // console.log(result.data)
        })
      }else{
        this.name = null
        this.type = null
      }
    },
    actionchange(item) {
      this.nwname = item.name
      this.nwid = item.id
    },
    adddev() {
      // console.log({
        //     name: this.name,
        //     serial_id: this.serial,
        //     security_id: this.security,
        //     network: this.nwname,
        //     nwid: this.nwid,
        //     type: this.type,
        //     lora: this.loraid || '',
        //     token: this.$session.get('token')
        // })
      if(this.nwname != '' && this.serial != '' && this.security != '' && this.name!= '') {
        this.$http.post(this.$url+'gateway', {
          headers: {
                    'Access-Control-Request-Method': '*',
                    'Access-Control-Request-Headers': '*',
                    'Origin': '*'
                  },
            name: this.name,
            serial_id: this.serial,
            security_id: this.security,
            network: this.nwname,
            nwid: this.nwid,
            type: this.type,
            lora: this.loraid || '',
            token: this.$session.get('token')
        }).then(() => {
          this.$vs.notify({
            title: "Add Device",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
          setTimeout(() => {
            location.reload() 
          }, 200);
        })
      }else {
        this.$vs.notify({
          title: "Add Device",
          text: "Please fill in the form",
          color: "danger",
          position: "top-center",
          icon: 'cancel'
        });
      }
    }
  },
  created() {
    this.$http.get(this.$url+'network/'+this.$session.get('token')).then((result) => {
      this.nwlist = result.data
    })
  }
}
</script>
<style scoped>
.labelInput{
  font-size: .85rem;
  color: rgba(0,0,0,.7);
  }
.spanColor {
   /* content:" *";  */
   font-size: 20px;
   color: red;
   padding-top: 10px;
  }
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>